<template>
    <section class="gmp-section gmp-mb-l">

        <div class="subpage-hero">
            <div class="two-column-tout">
                <div class="h-c-page">
                    <div class="h-c-grid">
                        <div class="h-c-grid__col h-c-grid__col-xl--offset-1 h-c-grid__col-l--6 h-c-grid__col-xl--5  h-c-grid__col--align-middle
            two-column-tout__content">
                            <h1 class="h-c-headline h-c-headline--display-two h-has-bottom-margin">
                                持续的服务改进
                            </h1>
                            <div class="h-u-mb-std two-column-tout__description">
                                <p>
                                    由于平台的透明性和高效性，客户更愿意长期使用和信赖该平台，形成稳定的合作关系，增加客户的忠诚度。
                                </p>
                            </div>

                        </div>

                        <div class="h-c-grid__col  h-c-grid__col-l--6  h-c-grid__col--align-middle">
                            <div class="two-column-tout__image text-center">
                                <picture>
                                    <img src="@/assets/img/subpage.png" alt="" class="gmp-no-grab ">
                                </picture>
                            </div>
                        </div>

                    </div>
                </div>
            </div>


        </div>


    </section>
</template>

<script>
    export default {
        name: "PL_subpagehero"
    }
</script>

<style lang="less">


</style>